import React, { useEffect, useRef, useState } from 'react';
import StatCard from './StatCard';
import { stats } from '../../data/portfolioData';
import './Stats.css';

const Stats = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section">
      <div className="stats-grid" ref={ref}>
        {stats.map((stat, index) => (
          <StatCard
            key={index}
            stat={stat}
            visible={visible}
            delay={index * 150}
          />
        ))}
      </div>
    </section>
  );
};

export default Stats;
